import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { EditBadgePageRoutingModule } from './edit-badge-routing.module';
import { EditBadgePage } from './edit-badge.page';
import { ComponentsModule } from '../../../../../components/components.module';
import { ImageUploadComponent } from './components/image-upload/image-upload.component';

@NgModule({
  imports: [
    CommonModule,
    ComponentsModule,
    ReactiveFormsModule,
    IonicModule,
    EditBadgePageRoutingModule,
  ],
  declarations: [EditBadgePage, ImageUploadComponent],
})
export class EditBadgePageModule {}
